import { Link } from "react-router-dom";
import { motion } from "framer-motion";
export default function RealEstate() {
  return (
     <motion.div
      className="max-w-4xl mx-auto px-6 py-12 text-center"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <h1 className="text-3xl md:text-4xl font-bold mb-6">Real Estate</h1>
      <p className="text-lg text-gray-700 leading-relaxed mb-8 text-left">
        We provide comprehensive legal support for both residential and commercial real estate transactions, guiding our clients through purchases, sales, and refinancing with clarity and confidence.
Whether you are a first-time homebuyer, a seasoned investor, or a business owner acquiring commercial property, we ensure that your transaction is smooth, timely, and handled with legal precision. From reviewing purchase contracts to conducting title searches and preparing closing documents, we manage every detail with precision and care.
We prioritize clear and proactive communication so that you are never left guessing about the next step. With Falcon Law, you will receive practical legal advice, and responsive support throughout your transaction.
Whether it’s your home, your next investment, or your company’s future premises, we are here to protect your interests and make your real estate experience as seamless as possible.

      </p>
      <Link
        to="/contact"
        className="inline-block px-6 py-3 rounded-lg bg-blue-900 text-white font-semibold shadow hover:bg-blue-800 transition"
      >
        Request Consultation
      </Link>
    </motion.div>
  );
}
